function fillRange(min, max) {
  const range = [];
  while (min <= max) {
    range.push(min++);
  }
  return range;
}

function generateCopiesList(setCopies, maxQuantity = 999) {
  // This code has been left in order to facilitate zero down time
  // the setCopies coming from the server had been a comma delimited string but
  // has been changed to an actual array like this code creates.
  // This code will become redundant once the caches are built post deployment of sprint 51
  // >>>>>>>>>> start of redundant part
  if (typeof setCopies === 'string') {
    return setCopies.split(',').map((e) => {
      if (e.includes('-')) {
        const [min, max] = e.split('-').map((n) => parseInt(n, 10));
        return fillRange(min, max);
      }
      return [parseInt(e, 10)];
    }).reduce((a, b) => a.concat(b)).sort((a, b) => a - b)
      .filter((a, index, self) => index === self.indexOf(a));
  }
  // <<<<<<<<< end of redundant part

  return setCopies || fillRange(1, maxQuantity);
}

export default generateCopiesList;
